export default "__VITE_ASSET__ByKNVh7l__"